import { AIWriter } from '@ui/components'

export default function Unauthorized() {
	return (
		<div className='flex flex-col items-center justify-center h-screen m-auto max-w-lg text-center p-8'>
			<AIWriter delay={ 100 }>
				<div className='text-4xl font-bold'>This link seems to be expired 💀</div>
				<div className='text-xl mt-4'>We couldn&apos;t load this page. Please check that this link is still available or regenerate a new one from your user panel.</div>
			</AIWriter>
		</div>
	)
}
